<template>
  <div class="opple-ability-ui-com-timeRange">
    <el-time-picker
      v-model="startTime"
      format="HH:mm"
      :placeholder="$t('ifttt.timeStart')"
    />
    <span class="title_middle"> {{ $t('ifttt.timeAdd') }} </span>
    <el-time-picker
      v-model="endTime"
      format="HH:mm"
      :placeholder="$t('ifttt.timeEnd')"
    />
    <div class="reset_btn" @click="setTime">
      {{ $t('deviceMsg.calibrateLUXButton') }}
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      startTime: null,
      endTime: null
    }
  },

  computed: {
   
  },

  mounted() {
    this.setTime();
  },

  methods: {
    //十六进制转换为十进制
    hexToDec(hex) {
      return parseInt(hex, 16);
    },
    // 十进制转换为十六进制，并补齐两位
    decToHex(dec) {
      return dec.toString(16).padStart(2, '0');
    },
    setTime() {
      const { DefaultValue } = this.item;

      if (!DefaultValue) return;
     
      const start = parseInt(DefaultValue.slice(0, 2), 16) + ':' + parseInt(DefaultValue.slice(2, 4), 16);
      const end = parseInt(DefaultValue.slice(4, 6), 16) + ':' +parseInt(DefaultValue.slice(6, 8), 16);
      this.startTime = moment(start, "HH:mm");
      this.endTime = moment(end, "HH:mm");
    },
    getData() {
      const [hour1, minute1] = moment(this.startTime, "HH:mm").format('HH:mm').split(':').map(Number);
      const [hour2, minute2] = moment(this.endTime, "HH:mm").format('HH:mm').split(':').map(Number);
      const start = this.decToHex(hour1) + this.decToHex(minute1);
      const end = this.decToHex(hour2) + this.decToHex(minute2);
      const finalStr = start + end;

      return {
        Key: this.item.KeyId,
        Values: [finalStr]
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.opple-ability-ui-com-timeRange {
  .title_middle{
    display: inline-block;
    margin: 0 4px;
  }

  .reset_btn{
    margin-left: 20px;
    font-size: 12px;
    color: #0E4CAD;
    cursor: pointer;
  }
}
</style>
